<template>
    <div class="container">
        <a-form-model :model="form" :rules="rules" ref="form"
            :labelCol="{ span: 5 }" :wrapperCol="{ span: 10 }"
            hideRequiredMark class="addTowerForm"
        >
            <a-form-model-item prop="file"
                :labelCol="{ span: 3 }" :wrapperCol="{ span: 18, offset: 3 }"
            >
                <a-upload
                    name="file" accept=".zip"
                    :multiple="false" :before-upload="() => false"
                    @change="handleChange" :fileList="fileList"
                >
                    <a-button><a-icon type="upload" />塔的文件(只支持.zip格式)</a-button>
                </a-upload>
            </a-form-model-item>
            <a-form-model-item label="英文名" prop="name">
                <a-input size="default" v-model="form.name" placeholder="塔的唯一标识符" />
            </a-form-model-item>
            <a-form-model-item label="中文名" prop="title">
                <a-input v-model="form.title" placeholder="塔的中文名" />
            </a-form-model-item>
            <a-form-model-item label="作者用户编号" prop="autherId">
                <a-input v-model="form.authorId" placeholder="供自助更新使用" />
            </a-form-model-item>
            <a-form-model-item label="复刻塔">
                <a-switch v-model="form.remastered"/>
            </a-form-model-item>
            <a-form-model-item :label="form.remastered ? '原作者' : '作者'" prop="author">
                <a-input v-model="form.author" />
            </a-form-model-item>
            <a-form-model-item v-if="form.remastered" label="复刻者">
                <a-input v-model="form.author2" />
            </a-form-model-item>
            <a-form-model-item label="链接" prop="link" :wrapperCol="{ span: 14 }">
                <a-input v-model="form.link" />
            </a-form-model-item>
            注意：请至少开始一次游戏，不然主页将无法显示！
            <a-form-model-item label="不显示提交记录">
                <a-switch v-model="form.competition"/>
            </a-form-model-item>
            <a-form-model-item label="第三方BGM">
                <a-switch v-model="form.bgmremote"/>
            </a-form-model-item>
            <a-form-model-item label="标签" :wrapperCol="{ span: 14 }">
                <a-checkbox-group :options="tags" v-model="tagProxy" />
            </a-form-model-item>
            <a-form-model-item label="颜色">
                白（新塔发布时默认为白）
            </a-form-model-item>
            <a-form-model-item label="所在目录" prop="dir">
                <a-input v-model="form.dir" />
            </a-form-model-item>
            <a-form-model-item label="作者的话" :wrapperCol="{ span: 14 }">
                <a-textarea placeholder="显示在底部的话" v-model="form.text" :rows="3" />
            </a-form-model-item>
            <a-form-model-item v-if="uploading" :wrapperCol="{ span: 18, offset: 3 }">
                <a-progress :percent="uploadprogress" :format="uploadingFormat" status="active" />
            </a-form-model-item>
            <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">
                <a-button type="primary" @click="submit" :loading="uploading">
                    发布
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </div>
</template>

<script>
import { TAGS } from "../../../constant.js"
import axios from '../../../plugins/axios.js';
import { createFormData } from '../../../utils/utils.js';

export default {
    data: () => ({
        form: {
            name: "",
            title: "",
            authorId: "",
            author: "",
            author2: "",
            remastered: false,
            competition: false,
            link: "",
            text: "",
            tag: "",
            dir: "",
            file: false,
            bgmremote: false,
        },
        uploadprogress: 0,
        uploading: false,
        fileList: [],
        rules: {
            name: [
                { validator: (rule, value, res) => {
                    if (!/^[a-zA-Z0-9_]+$/.test(value)) {
                        res(new Error("标识符只能由大小写字母和数字组成"));
                    } else res();
                }, trigger: 'blur' },
                { required: true, trigger: 'blur' }
            ],
            title: [
                { required: true, trigger: 'blur' }
            ],
            authorId: [
                { validator: (rule, value, res) => {
                    if (!/^(\d{4,4})?$/.test(value)) {
                        res(new Error("用户编号是四位数字"));
                    } else res();
                }, trigger: 'blur' },
            ],
            author: [
                { required: true, trigger: 'blur' }
            ],
            link: [
                { required: true, trigger: 'blur' }
            ],
            file: [
                { validator: (rule, value, res) => {
                    if (value) {
                        res();
                    } else {
                        res(new Error("必须提供塔的压缩包"));
                    }
                }, trigger: 'blur' }
            ],
        },
        tags: TAGS.filter(e => e != "复刻塔")
    }),
    computed: {
        tagProxy: {
            get() {
                if (this.form.tag === "") return [];
                return this.form.tag.split('|');
            },
            set(value) {
                this.form.tag = value.join('|');
            }
        }
    },
    methods: {
        uploadingFormat(percent) {
            if (percent == 100) return "正在解压";
            else return percent + '%';
        },
        handleChange(info) {
            switch(info.file.status) {
                case "remove":
                    if (this.form.title == this.form.file.name.slice(0, -4)) {
                        this.form.title = '';
                    }
                    this.form.file = false;
                    break;
                default: 
                    this.form.file = true;
                    if (!this.form.title) {
                        this.form.title = info.file.name.slice(0, -4);
                    }
            }
            this.fileList = info.fileList;
        },
        submit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.form.file = this.fileList[0].originFileObj;
                    window.handler = this;
                    this.uploadprogress = 0;
                    this.uploading = true;
                    axios.post("/backend/admin/tower/add.php", createFormData(this.form), {
                        onUploadProgress: (e) => {
                            this.uploadprogress = (e.loaded / e.total * 100 | 0);
                        }
                    })
                        .then(({ data }) => {
                            this.fileList = [];
                            if (data.code == 0) {
                                this.$message.success("发布成功");
                                this.$refs.form.resetFields();
                            } else {
                                this.$error({
                                    title: '发布失败',
                                    width: '85%',
                                    content: h => (<pre class="message">{ data.message }</pre>),
                                });
                            }
                            this.uploading = false;
                        });
                }
            });
        }
    },
    watch: {
        "form.name": function(value, old) {
            if (!value) this.form.link = '';
            else if (!this.form.link
                || this.form.link == `https://h5mota.com/games/${ old }/`) {
                this.form.link = `https://h5mota.com/games/${ value }/`;
            }
        },
        "form.remastered": function(value, old) {
            if (value) this.tagProxy = ["复刻塔"].concat(this.tagProxy);
            else this.tagProxy = this.tagProxy.filter(e => e != "复刻塔");
        }
    }
}
</script>

<style lang="less">
.addTowerForm {
    .ant-form-item {
        margin-bottom: 8px;
    }
}
pre.message {
    height: 300px;
    overflow: auto;
}
</style>

<style lang="less" scoped>
.container {
    height: 100%;
    overflow: auto;
}
</style>